import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse, DropdownToggle, Dropdown, DropdownMenu } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"
import { useSelector } from "react-redux"
//i18n
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import adminicon from "../../assets/images/adminicon.png"
import reporticon from "../../assets/images/Reporticons.png"
//helpers
import { getUserNames } from "helpers/storagehelper"

const Navbar = props => {
  const [ui, setui] = useState(false)
  const [app, setapp] = useState(false)
  const [email, setemail] = useState(false)
  const [reports, setReports] = useState(false)
  const [admins, setAdmins] = useState(false)

  const MainCategory = JSON.parse(localStorage.getItem("authUser") || "{}")
    ?.data?.companysetting?.maincategoryname

  const { accessSetting, accessgroupname } = useSelector(state => ({
    accessSetting: state?.Login?.accessDetails?.data,
    accessgroupname: state?.Login?.usersDetails?.data,
  }))

  const hideAllTeamsbutton = accessSetting?.createTeam
  const hideMainCategorybutton = accessSetting?.createMainCat
  const hideSubCategorybutton = accessSetting?.createSubCat
  const accessGroupname =
    accessgroupname?.accessgroupname === "User" ||
    accessgroupname?.accessgroupname === "CategoryUser"

  const reportingenabled = accessgroupname?.reportingenabled
  const accessGroupnameCategoryUsers =
    accessgroupname?.accessgroupname === "CategoryUser"

  const hideTimeLog = accessgroupname?.accessgroupname === "CategoryUser"
  const HoursReportPage = accessgroupname?.useraccessgroupsettings?.adminReports
  const WebHookPage = accessgroupname?.useraccessgroupsettings?.webhook
  const hasAccessAllTeam = accessgroupname?.useraccessgroupsettings?.accessAllTeam

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  // ** handled outside click to close mobile menu ** //
  useEffect(() => {
    if ((ui || app || email) && props?.match?.path) {
      props.setActiveCollapse(false)
    }
  }, [ui, app, email])

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          {accessGroupnameCategoryUsers && (
            <div className="d-flex">
              <div
                className=" header-item d-flex align-items-center me-3"
                style={{ height: "60px" }}
              >
                <i
                  className="fa fa-file me-2"
                  aria-hidden="true"
                  width={18}
                  height={18}
                  style={{
                    color: "#fff",
                    cursor: "pointer",
                  }}
                />
                <Link to="/client/viewhours">
                  <div className="d-flex" style={{ color: "#fff" }}>
                    {props.t("Reports")}
                  </div>
                </Link>
              </div>

              <div
                className=" header-item d-flex align-items-center"
                style={{ height: "55px" }}
              >
                <Link to="/client/viewscreens" className="d-flex">
                  <i
                    className="fas fa-camera me-2"
                    width={18}
                    height={18}
                    style={{
                      color: "#fff",
                      cursor: "pointer",
                      paddingTop: "10px",
                    }}
                  />
                  <div
                    className="d-flex"
                    style={{ color: "#fff", paddingTop: "7px" }}
                  >
                    {props.t("Screens")}
                  </div>
                </Link>
              </div>
            </div>
          )}
          {!accessGroupnameCategoryUsers && (
            <Dropdown
              isOpen={reports}
              toggle={() => setReports(!reports)}
              className="d-inline-block desktop-hidesdrop"
            >
              <DropdownToggle
                className="btn header-item d-flex align-items-center"
                id="page-header-user-dropdown"
                tag="button"
                style={{
                  height: "50px",
                  boxShadow: "none",
                  color: "#555b6d",
                  border: 0,
                  borderRadius: 0,
                  position: "relative",
                  paddingLeft: 0,
                }}
              >
                <img
                  src={reporticon}
                  width={18}
                  height={18}
                  className="admin-icons-size"
                />
                <div className="d-flex" style={{ color: "#fff" }}>
                  {props.t("Reports")} <div className="arrow-down"></div>
                </div>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-start">
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      to="/verifyscreen"
                      className={
                        props?.match?.path === "/verifyscreen"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {props.t("View My hours")}
                    </Link>
                    {(accessGroupname == false || reportingenabled) && (
                      <Link
                        to="/verifyscreenTeams"
                        className={
                          props?.match?.path === "/verifyscreenTeams"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("View Team hours")}
                      </Link>
                    )}

                    {!hideTimeLog && (
                      <Link
                        to="/usertimelog"
                        className={
                          props?.match?.path === "/usertimelog"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("View Time Log")}
                      </Link>
                    )}

                    {hasAccessAllTeam && (
                      <Link
                        to="/useractivitylog"
                        className={
                          props?.match?.path === "/useractivitylog"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("View Activity Log")}
                      </Link>
                    )}
                  </li>
                </ul>
              </DropdownMenu>
            </Dropdown>
          )}
          {!accessGroupnameCategoryUsers && accessGroupname === false && (
            <Dropdown
              isOpen={admins}
              toggle={() => setAdmins(!admins)}
              className="d-inline-block desktop-hidesdrop"
            >
              <DropdownToggle
                className="btn header-item d-flex align-items-center me2"
                id="page-header-user-dropdown"
                tag="button"
                style={{
                  height: "50px",
                  boxShadow: "none",
                  color: "#555b6d",
                  border: 0,
                  borderRadius: 0,
                  position: "relative",
                }}
              >
                <img
                  src={adminicon}
                  width={18}
                  height={18}
                  className="admin-icons-size"
                />
                <div className="d-flex" style={{ color: "#fff" }}>
                  {props.t("Admin")} <div className="arrow-down"></div>
                </div>
              </DropdownToggle>
              <DropdownMenu
                className="dropdown-menu-start navbar-collapse"
                id="topnav-menu-content"
              >
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      to="/manageaccessgroup"
                      className={
                        props?.match?.path === "/manageaccessgroup"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {props.t("Manage Access Group Settings")}
                    </Link>

                    <Link
                      to="/manageuser"
                      className={
                        props?.match?.path === "/manageuser"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {props.t("Manage Users")}
                    </Link>
                    <Link
                      to="/trackprofile"
                      className={
                        props?.match?.path === "/trackprofile"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {props.t("Manage Trac Profile")}
                    </Link>
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link
                        to="/organisation"
                        className={
                          props?.match?.path === "/organisation"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Manage Organizations")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link
                        to="/applicationsetup"
                        className={
                          props?.match?.path === "/applicationsetup"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Manage Application Setup")}
                      </Link>
                    )}
                  </li>
                </ul>
                <div className="dropdown">
                  <>
                    <ul className="navbar-nav">
                      <li className="nav-item dropdown">
                        <Link
                          className="dropdown-item dropdown-toggle arrow-none"
                          to="/#"
                          onClick={e => {
                            e.preventDefault()
                            setemail(!email)
                          }}
                        >
                          <span key="t-email-templates">Manage Teams</span>
                          <div className="arrow-down"></div>
                        </Link>
                      </li>
                    </ul>
                    <div
                      className={classname("dropdown-menu", {
                        show: email,
                      })}
                    >
                      <ul className="navbar-nav">
                        <li className="nav-item dropdown">
                          {hideAllTeamsbutton == true ? (
                            <Link
                              to="/createteam"
                              className={
                                props?.match?.path === "/createteam"
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                            >
                              {props.t("Create Teams")}
                            </Link>
                          ) : (
                            ""
                          )}
                          <Link
                            to="/manageteam"
                            className={
                              props?.match?.path === "/manageteam"
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            {props.t("Manage Teams")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </>
                </div>
                {hideMainCategorybutton == false &&
                  hideSubCategorybutton == false ? (
                  ""
                ) : (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/manageclient"
                        className={
                          props?.match?.path === "/manageclient"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Manage " + MainCategory)}
                      </Link>
                    </li>
                    <li className="nav-item dropdown">
                      <Link
                        to="/erp-clients"
                        className={
                          props?.match?.path === "/erp-clients" ||
                          props?.match?.path === "/erp-client/:id"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("ERP Clients")}
                      </Link>
                    </li>
                    <li className="nav-item dropdown">
                      <Link
                        to="/crm-organizations"
                        className={
                          props?.match?.path === "/crm-organizations" ||
                          props?.match?.path === "/crm-organization/:id"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("CRM Organizations")}
                      </Link>
                    </li>
                  </ul>
                )}
                { HoursReportPage == false ? ("")
                  : (
                    <ul className="navbar-nav">
                      <li className="nav-item dropdown">
                        <Link
                          to="/hoursreportv1"
                          className={
                            props?.match?.path === "/hoursreportv1"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                        >
                          {props.t("Hours Report V1")}
                        </Link>
                      </li>
                    </ul>
                  )}
                {WebHookPage == true && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/webhooks"
                        className={
                          props?.match?.path === "/webhooks"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Web Hooks")}
                      </Link>
                    </li>
                  </ul>
                )}
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/workspace-audit"
                        className={
                          props?.match?.path === "/workspace-audit"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Workspace Audit")}
                      </Link>
                    </li>
                  </ul>
                )}
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/workspace-audit-executive"
                        className={
                          props?.match?.path === "/workspace-audit-executive"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Workspace Audit Summary")}
                      </Link>
                    </li>
                  </ul>
                )}
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/workfromhome"
                        className={
                          props?.match?.path === "/workfromhome"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Work From Home")}
                      </Link>
                    </li>
                  </ul>
                )}
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/scrutinynotes"
                        className={
                          props?.match?.path === "/scrutinynotes"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Scrutiny Notes")}
                      </Link>
                    </li>
                  </ul>
                )}                
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      to="/calculateincentives"
                      className={
                        props?.match?.path === "/calculateincentives"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {props.t("Calculate Incentives")}
                    </Link>
                  </li>
                </ul>
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/attendancedetails"
                        className={
                          props?.match?.path === "/attendancedetails"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Attendance Details")}
                      </Link>
                    </li>
                  </ul>
                )}
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/aiusagereport"
                        className={
                          props?.match?.path === "/aiusagereport"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("AI Usage Report")}
                      </Link>
                    </li>
                  </ul>
                )}
                {accessgroupname?.accessgroupname === "Admin" && (
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <Link
                        to="/aiusagedashboard"
                        className={
                          props?.match?.path === "/aiusagedashboard"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("AI Usage Dashboard")}
                      </Link>
                    </li>
                  </ul>
                )}
              </DropdownMenu>
            </Dropdown>
          )}
          {!accessGroupnameCategoryUsers &&
            getUserNames() &&
            accessGroupname === false && (
              <div className="d-inline-block desktop-hidesdrop px-2 position-relative top-0">
                <Link to="/help">
                  <div
                    className="d-flex"
                    style={{ color: "#fff", position: "relative", top: "-5px" }}
                  >
                    {props.t("Help")}
                  </div>
                </Link>
              </div>
            )}

          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu desktop-hidesnavs"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  {accessGroupnameCategoryUsers == false && (
                    <Link
                      to="/#"
                      onClick={e => {
                        e.preventDefault()
                        setui(!ui)
                        props.setActiveCollapse(!ui)
                      }}
                      className="nav-link dropdown-togglez arrow-none"
                    >
                      <img
                        src={reporticon}
                        width={15}
                        height={13}
                        className="admin-icons-size"
                      />
                      {props.t("Reports")} <div className="arrow-down"></div>
                    </Link>
                  )}
                  <div className={classname("dropdown-menu", { show: ui })}>
                    <Link to="/verifyscreen" className="dropdown-item">
                      {props.t("View My hours")}
                    </Link>
                    {(accessGroupname == false || reportingenabled) && (
                      <Link to="/verifyscreenTeams" className="dropdown-item">
                        {props.t("View Team hours")}
                      </Link>
                    )}
                    {!hideTimeLog && (
                      <Link to="/usertimelog" className="dropdown-item">
                        {props.t("View Time Log")}
                      </Link>
                    )}
                    {hasAccessAllTeam && (
                      <Link to="/useractivitylog" className="dropdown-item">
                        {props.t("View Activity Log")}
                      </Link>
                    )}
                  </div>
                </li>

                <li className="nav-item dropdown">
                  {accessGroupname == false && (
                    <Link
                      to="/#"
                      onClick={e => {
                        e.preventDefault()
                        setapp(!app)
                        props.setActiveCollapse(!app)
                      }}
                      className="nav-link dropdown-togglez arrow-none"
                    >
                      {/* <i className="bx bx-customize me-2"></i> */}
                      <img
                        src={adminicon}
                        width={18}
                        height={18}
                        className="admin-icons-size"
                      />
                      {props.t("Admin")} <div className="arrow-down"></div>
                    </Link>
                  )}
                  <div className={classname("dropdown-menu", { show: app })}>
                    <Link to="/manageaccessgroup" className="dropdown-item">
                      {props.t("Manage Access Group Settings")}
                    </Link>
                    <Link to="/manageuser" className="dropdown-item">
                      {props.t("Manage Users")}
                    </Link>

                    <Link to="/trackprofile" className="dropdown-item">
                      {props.t("Manage Trac Profile")}
                    </Link>
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link to="/organisation" className="dropdown-item">
                        {props.t("Manage Organizations")}
                      </Link>
                    )}
                    <div className="dropdown">
                      <>
                        <Link
                          className="dropdown-item dropdown-toggle arrow-none"
                          to="/#"
                          onClick={e => {
                            e.preventDefault()
                            setemail(!email)
                            props.setActiveCollapse(!email)
                          }}
                        >
                          <span key="t-email-templates">Manage Teams</span>
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: email,
                          })}
                        >
                          {hideAllTeamsbutton == true ? (
                            <Link to="/createteam" className="dropdown-item">
                              {props.t("Create Teams")}
                            </Link>
                          ) : (
                            ""
                          )}
                          <Link to="/manageteam" className="dropdown-item">
                            {props.t("Manage Teams")}
                          </Link>
                        </div>
                      </>
                    </div>
                    {hideMainCategorybutton == false &&
                      hideSubCategorybutton == false ? (
                      ""
                    ) : (
                      <Link to="/manageclient" className="dropdown-item">
                        {props.t("Manage " + MainCategory)}
                      </Link>
                    )}
                      {HoursReportPage === false ? (
                        ""
                      ) : (
                        <Link
                          to="/hoursreportv1"
                          className={
                            props?.match?.path === "/hoursreportv1"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                        >
                          {props.t("Hours Report V1")}
                        </Link>
                      )}

                    {WebHookPage == true && (
                      <Link to="/webhooks" className="dropdown-item">
                        {props.t("Web Hooks")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link to="/workspace-audit" className="dropdown-item">
                        {props.t("Workspace Audit")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link to="/workspace-audit-executive" className="dropdown-item">
                        {props.t("Workspace Audit Summary")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link
                        to="/reportsubmittedtime"
                        className={
                          props?.match?.path === "/reportsubmittedtime"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("Report Submitted Time")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link to="/workfromhome" className="dropdown-item">
                        {props.t("Work From Home")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link to="/scrutinynotes" className="dropdown-item">
                        {props.t(" Scrutiny Notes")}
                      </Link>
                    )}
                    {/* // get_allnonworkinghours */}
                    <Link to="/calculateincentives" className="dropdown-item">
                      {props.t(" Calculate Incentives")}
                    </Link>
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link to="/attendancedetails" className="dropdown-item">
                        {props.t("Attendance Details")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link
                        to="/aiusagereport"
                        className={
                          props?.match?.path === "/aiusagereport"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("AI Usage Report")}
                      </Link>
                    )}
                    {accessgroupname?.accessgroupname === "Admin" && (
                      <Link
                        to="/aiusagedashboard"
                        className={
                          props?.match?.path === "/aiusagedashboard"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        {props.t("AI Usage Dashboard")}
                      </Link>
                    )}
                  </div>
                </li>
                <li className="nav-item dropdown">
                  {accessGroupname == false && (
                    <Link
                      to="/help"
                      className="nav-link dropdown-togglez arrow-none"
                    >
                      <img
                        src={adminicon}
                        width={18}
                        height={18}
                        className="admin-icons-size"
                      />
                      {props.t("Help")}
                    </Link>
                  )}
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
